<template>
  <v-row class="px-2" style="border:solid 1px #e4e4e4;">
    <v-col class="d-flex font-weight-medium align-center" cols="12" md="2" lg="2" sm="2">
      <span>Select Requested City:</span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <v-autocomplete
        v-model="requestedCity"
        label="Select Requested City"
        :items="cityArray"
        item-text="cityName"
        item-value="id"
        outlined
        dense
        hide-details
        @change="onRequestedCityChange"
      />
    </v-col>
    <v-col class="d-flex font-weight-medium align-center" cols="12" md="2" lg="2" sm="2">
      <span>Select Requested Center:</span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <v-autocomplete
        label="Select Requested Center"
        :items="centerArray"
        item-text="companyName"
        item-value="id"
        v-model="requestedCenter"
        outlined
        dense
        hide-details
        @change="onRequestedCenterChange"
      />
    </v-col>

    <v-col class="d-flex font-weight-medium align-center" cols="12" md="2" lg="2" sm="2">
      <span>Select Fee Plan: </span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <v-autocomplete
        label="Select fee plan"
        :items="feePlanList"
        item-text="name"
        item-value="id"
        v-model="selectedFeePlan"
        outlined
        dense
        hide-details
      />
    </v-col>

    <v-col class="d-flex font-weight-medium" cols="12" md="2" lg="2" sm="2">
      <span>Expected Last Date For Current School:</span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <student-dob
        v-model="currentSchoolDate"
        :maxDate="exitMaxDate"
        :minDate="computedMinDate"
        :label="`Expected Last Date For Current School`"
        outlined
        dense
        hide-details
      />
    </v-col>
    <v-col class="d-flex font-weight-medium" cols="12" md="2" lg="2" sm="2">
      <span>Expected Joining Date For New School:</span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <student-dob
        v-model="newSchoolDate"
        :minDate="minDate"
        :label="`Expected Joining Date For New School`"
        outlined
        dense
      />
    </v-col>

    <v-col class="d-flex font-weight-medium" cols="12" md="2" lg="2" sm="2">
      <span>Plan Applicable Months:</span>
    </v-col>
    <v-col cols="12" md="10" lg="10" sm="10">
      <v-select
        v-model="applicableMonths"
        :items="monthApplicable"
        label="Select applicable months"
        dense
        outlined
        @change="onApplicableMonthsChange"
      />
    </v-col><br></br>

    <!-- Old Centre Months -->
    <v-col class="d-flex font-weight-medium" cols="12" md="2" lg="2" sm="2">
      <span>Old Centre Months:</span>
    </v-col>
    <v-col cols="12" md="4" lg="4" sm="4">
      <v-select
        v-model="oldCentreMonths"
        :items="monthOptions"
        label="Select Old Centre Months"
        dense
        outlined
        @change="onOldMonthChange"
      />
      <div class="text-caption mt-0">
        Note: This number is calculated based on the student’s Date of Admission and reflects the selected month accordingly.
      </div>
    </v-col>

    <!-- New Centre Months -->
    <v-col class="d-flex font-weight-medium" cols="12" md="2" lg="2" sm="2">
      <span>New Centre Months:</span>
    </v-col>
    <v-col cols="12" md="4" lg="4" sm="4">
      <v-select
        v-model="newCentreMonths"
        :items="monthOptions"
        label="Select New Centre Months"
        dense
        outlined
        @change="onNewMonthChange"
      />
    </v-col>
  </v-row>
</template>
<script>
import moment from 'moment'
import constants from '@/utils/constants'
import StudentDob from '@/components/BranchTransferV1/component/date/dateComponent'
export default {
  name: 'BranchTransferDetailsFormComponent',
  props: {
    enrollmentCodeId: {
      type: String,
      default: null
    },
    oldFranchiseeId: {
      type: Number,
      default: null
    },
    monthData: {
      type: Object,
      default: null
    },
    studentDetails: {
      type: Object,
      default: null
    }
  },
  components: {
    StudentDob
  },
  data () {
    return {
      cityArray: [],
      centerArray: [],
      currentSchoolDate: null,
      newSchoolDate: null,
      requestedCity: null,
      requestedCenter: null,
      exitMaxDate: moment().format('YYYY-MM-DD'),
      minDate: moment().format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      oldCentreMonths: null,
      newCentreMonths: null,
      monthOptions: Array.from({ length: 13 }, (_, i) => i),
      monthApplicable: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      feePlanList: [],
      applicableMonths: 1,
      selectedFeePlan: null,
      studentAdmisssionID: null,
      updatingFromProp: false
    }
  },
  computed: {
    computedMinDate () {
      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth()

      const fiscalYearStart = currentMonth >= 3 ? currentYear : currentYear - 1
      const aprilFirst = new Date(fiscalYearStart, 3, 1)
      const yyyy = aprilFirst.getFullYear()
      const mm = String(aprilFirst.getMonth() + 1).padStart(2, '0')
      const dd = String(aprilFirst.getDate()).padStart(2, '0')

      return `${yyyy}-${mm}-${dd}`
    }
  },
  watch: {
    currentSchoolDate: function (newVal) {
      if (newVal) {
        this.minDate = newVal
        this.maxDate = this.newSchoolDate
        this.$emit('setExitDate', newVal)
      }
    },
    newSchoolDate: function (newVal) {
      if (newVal) {
        this.minDate = this.currentSchoolDate
        this.maxDate = newVal
        this.$emit('setNewJoiningDate', newVal)
      }
    },
    requestedCenter: function (newVal) {
      this.$emit('setNewFranchiseeId', newVal)
    },
    enrollmentCodeId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetBranchTransferDetailsForm()
      }
    },
    oldFranchiseeId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.getFranchiseeList()
      }
    },
    monthData: function (newVal) {
      if (newVal) {
        this.oldCentreMonths = newVal?.franchisee?.old || 0
        this.newCentreMonths = newVal?.franchisee?.new || 0
        this.applicableMonths = newVal?.applicableMonths || 1
      }
    },
    studentDetails: {
      handler (newVal, oldVal) {
        const newId = newVal?.id
        const oldId = oldVal?.id

        if (newId !== oldId) {
          this.requestedCenter = null
          this.studentAdmisssionID = newId || null
          this.selectedFeePlan = null
          this.feePlanList = []
        } else {
          this.requestedCenter = null
          this.studentAdmisssionID = null
          this.selectedFeePlan = null
          this.feePlanList = []
        }
      },
      immediate: true
    },
    selectedFeePlan: function (newVal) {
      if (newVal) {
        let feePlanData = this.feePlanList.find(plan => plan.id === newVal)
        this.$emit('setNewFeePlan', feePlanData)
      } else {
        this.$emit('setNewFeePlan', null)
      }
    }
  },
  async created () {
    await this.getCityList()
  },
  methods: {
    onOldMonthChange (val) {
      this.oldCentreMonths = val
      this.emitMonthData()
    },
    onNewMonthChange (val) {
      this.newCentreMonths = val
      this.emitMonthData()
    },
    onApplicableMonthsChange (val) {
      this.applicableMonths = val
      this.emitMonthData()
    },
    emitMonthData () {
      const data = {
        label: 'Month Completed',
        fieldType: 'monthCompleted',
        franchisee: {
          old: this.oldCentreMonths,
          new: this.newCentreMonths
        },
        parent: {
          old: this.oldCentreMonths,
          new: this.newCentreMonths
        },
        applicableMonths: this.applicableMonths || 1
      }

      this.$emit('update:monthData', data)
    },
    async onRequestedCityChange (val) {
      let selectedCityName = this.cityArray.find(city => city.id === val)
      if (selectedCityName) {
        await this.getFranchiseeList(selectedCityName)
      }
      this.requestedCenter = null
      this.selectedFeePlan = null
      this.oldCentreMonths = null
      this.newCentreMonths = null
      this.emitMonthData()
      this.$emit('reset', null)
    },
    onRequestedCenterChange () {
      const selectedCenter = this.centerArray.find(center => center.id === this.requestedCenter)
      if (selectedCenter) {
        this.$dialog.info({
          title: 'Confirm Franchisee Selection',
          text: `
            <p><strong>Selected Franchisee:</strong> ${selectedCenter.companyName}</p>
            <p>You have selected the franchisee above for this student’s transfer request.</p>
            <p><strong>Is this the correct franchisee?</strong></p>
            <p>Please confirm before proceeding.</p>
          `,
          html: true,
          actions: {
            false: {
              text: 'No',
              handle: () => this.franchiseePopupAction('no')
            },
            true: {
              color: 'success',
              text: 'Yes',
              handle: async () => this.franchiseePopupAction('yes')
            }
          }
        })
      }
      // this.oldCentreMonths = null
      // this.newCentreMonths = null
      // this.monthData = null
    },
    async franchiseePopupAction (action) {
      // this.$emit('reset', null)
      if (action === 'yes') {
        this.selectedFeePlan = null
        await this.getFeePlanList()
      } else {
        this.requestedCenter = null
        this.selectedFeePlan = null
        this.feePlanList = []
      }
    },
    async getFeePlanList () {
      try {
        if (this.studentAdmisssionID && this.requestedCenter) {
          let params = {
            newFranchiseeID: this.requestedCenter
          }
          let { data } = await http.get(`${constants.API_URL}/api/V1/fee-component-by-admission/${this.studentAdmisssionID}`, { params })
          this.feePlanList = data || []
        } else {
          this.feePlanList = []
        }
      } catch (e) {
        this.feePlanList = []
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    resetBranchTransferDetailsForm: function () {
      this.currentSchoolDate = null
      this.newSchoolDate = null
      this.requestedCity = null
      this.requestedCenter = null
      this.oldCentreMonths = null
      this.newCentreMonths = null
      this.applicableMonths = 1
    },
    getCityList: async function () {
      this.cityArray = []
      http.get(`${constants.API_URL}/api/cityandstate/city-state-list`).then((res) => {
        if (res.status === 200) {
          res.data.forEach((item) => {
            if (typeof item.cities !== 'undefined' && item.cities.length > 0) {
              item.cities.forEach((obj) => {
                this.cityArray.push({
                  id: obj.id,
                  state: item.state,
                  cityName: obj.cityName,
                  isActive: obj.isActive
                })
              })
            }
          })
        } else {
          return this.errMsg(res.data)
        }
      }).catch((e) => {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      })
    },
    getFranchiseeList: async function (selectedData) {
      try {
        this.centerArray = []
        let params = {
          city: selectedData?.cityName,
          state: selectedData?.state
        }
        const response = await http.get(
          `${constants.API_URL}/api/v1/franchisee/active`, {
            params: params
          }
        )
        let data = response.data
        this.centerArray = Array.isArray(data.rows)
          ? data.rows
            .filter(obj => this.oldFranchiseeId !== obj.id)
            .map(obj => {
              const paddedId = obj.id.toString().padStart(3, '0')
              return { id: obj.id, companyName: `(${paddedId}) ${obj.companyName}` }
            })
          : []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
